import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";

export interface IFilterDifficultyControlsLogic {
  handleResetOnClick: () => void;
}

export const useFilterDifficultyControlsLogic = (): IFilterDifficultyControlsLogic => {
  return {
    handleResetOnClick: () => mySongsPageStore.resetFilterDifficulty(),
  };
}
